// @flow
import { AuthActionTypes } from "./constants";

import { APICore } from "../../helpers/api/apiCore";

const api = new APICore();

const INIT_STATE = {
  user: api.getLoggedInUser(),
  loading: false,
};

const Auth = (state = INIT_STATE, action) => {
  switch (action.type) {
    case AuthActionTypes.UPDATE_USER: {
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    }
    case AuthActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case AuthActionTypes.LOGIN_USER: {
          // A TOTP-enrolled user gets a challenge marker instead of a full user
          // object — hold at the code-entry step without signing them in.
          if (action.payload.data && action.payload.data.mfaRequired) {
            return {
              ...state,
              mfaRequired: true,
              loading: false,
            };
          }
          return {
            ...state,
            user: action.payload.data,
            userLoggedIn: true,
            mfaRequired: false,
            loading: false,
          };
        }

        case AuthActionTypes.CONFIRM_MFA: {
          return {
            ...state,
            user: action.payload.data,
            userLoggedIn: true,
            mfaRequired: false,
            loading: false,
          };
        }

        case AuthActionTypes.SIGNUP_USER: {
          return {
            ...state,
            loading: false,
            userSignUp: true,
          };
        }
        case AuthActionTypes.INVITATION_SIGNUP_USER: {
          return {
            ...state,
            loading: false,
            userSignUp: true,
          };
        }
        case AuthActionTypes.LOGOUT_USER: {
          return {
            ...state,
            user: null,
            loading: false,
            userLogout: true,
            userLoggedIn: false,
          };
        }
        case AuthActionTypes.FORGOT_PASSWORD: {
          return {
            ...state,
            resetPasswordSuccess: action.payload.data,
            loading: false,
            passwordReset: true,
          };
        }
        case AuthActionTypes.SET_NEW_PASSWORD: {
          return {
            ...state,
            resetPasswordSuccess: action.payload.data,
            loading: false,
            newPassword: true,
          };
        }
        case AuthActionTypes.VERIFY_EMAIL: {
          return {
            ...state,
            loading: false,
            verifyEmail: true,
          };
        }
        case AuthActionTypes.TOKEN_EXPIRATION: {
          return {
            ...state,
            user: null,
            loading: false,
            userLogout: true,
          };
        }
        default:
          return { ...state };
      }

    case AuthActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case AuthActionTypes.LOGIN_USER: {
          return {
            ...state,
            error: action.payload.error,
            userLoggedIn: false,
            loading: false,
          };
        }
        case AuthActionTypes.CONFIRM_MFA: {
          // Wrong code — keep the user at the code-entry step and show the error.
          // Expired/lost challenge (error.expired) — back to the password step, where
          // the same error message is shown as a warning.
          const expired = !!(action.payload.error && action.payload.error.expired);
          return {
            ...state,
            error: action.payload.error,
            userLoggedIn: false,
            mfaRequired: !expired,
            loading: false,
          };
        }
        case AuthActionTypes.SIGNUP_USER: {
          return {
            ...state,
            error: action.payload.error,
            userSignUp: false,
            loading: false,
          };
        }
        case AuthActionTypes.INVITATION_SIGNUP_USER: {
          return {
            ...state,
            error: action.payload.error,
            userSignUp: false,
            loading: false,
          };
        }
        case AuthActionTypes.FORGOT_PASSWORD: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            passwordReset: false,
          };
        }
        case AuthActionTypes.SET_NEW_PASSWORD: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            newPassword: false,
          };
        }
        case AuthActionTypes.VERIFY_EMAIL: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            verifyEmail: false,
          };
        }
        default:
          return { ...state };
      }

    case AuthActionTypes.LOGIN_USER:
      return { ...state, loading: true, userLoggedIn: false };
    case AuthActionTypes.CONFIRM_MFA:
      return { ...state, loading: true, error: null };
    case AuthActionTypes.LOGOUT_USER:
      return { ...state, loading: true, userLogout: false };
    case AuthActionTypes.SIGNUP_USER:
      return { ...state, loading: true, userSignUp: false };
    case AuthActionTypes.INVITATION_SIGNUP_USER:
      return { ...state, loading: true, userSignUp: false };
    case AuthActionTypes.FORGOT_PASSWORD:
      return { ...state, loading: true, passwordReset: false };
    case AuthActionTypes.SET_NEW_PASSWORD:
      return { ...state, loading: true, newPassword: false };
    case AuthActionTypes.VERIFY_EMAIL:
      return { ...state, loading: true, verifyEmail: false };
    case AuthActionTypes.RESET:
      return {
        ...state,
        loading: false,
        error: false,
        userSignUp: false,
        userLoggedIn: false,
        mfaRequired: false,
        passwordReset: false,
        newPassword: false,
        passwordChange: false,
        resetPasswordSuccess: null,
        verifyEmail: false,
      };
    default:
      return { ...state };
  }
};

export default Auth;